<template>
    <div>
        <section class="section has-background-black">
            <br><br><br>
            <div class="container has-text-centered">
                <h1 class="title has-text-white">We partner with leading agents</h1>
                <p class="subtitle is-6 has-text-white">By partnering with NestEgg, Agents access the best mandated properties to grow their business.</p>
            </div>
            <br><br><br>
        </section>

        <section class="section has-text-centered">
            <div class="container">
                <div class="columns is-centered shift-up">
                    <div class="column grey-column is-2">
                        <h3>Stock</h3>
                        <br>
                        <img alt="Stock" class="benefit-icon" src="../assets/images/for_agents/stock.svg">
                        <p>You get access to our listing stock</p>
                    </div>
                    <div class="column grey-column is-2">
                        <h3>Specialise</h3>
                        <br>
                        <img alt="Specialise" class="benefit-icon" src="../assets/images/for_agents/specialise.svg">
                        <p>We <strong>only</strong> specialise in sellers - not buyers</p>
                    </div>
                    <div class="column grey-column is-2">
                        <h3>Focus</h3>
                        <br>
                        <img alt="Focus" class="benefit-icon" src="../assets/images/for_agents/focus.svg">
                        <p>You focus on buyers - not sellers</p>
                    </div>
                    <div class="column grey-column is-2">
                        <h3>Sharing</h3>
                        <br>
                        <img alt="Sharing" class="benefit-icon" src="../assets/images/for_agents/sharing.svg">
                        <p>You receive 60% of agent commission</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <h2 class="title has-text-centered">How we partner with leading agents</h2>
                <div class="columns is-vcentered">
                    <div class="column">
                        <h3 class="title">What we do as the Sellers' Agent</h3>
                        <ul class="ul-bullets">
                            <li>Enter into a Listing Agreement with our seller</li>
                            <li>List the property on our NestEgg website</li>
                            <li>Engage with you as Buyers' Agent</li>
                            <li>Provide you with all listing details</li>
                            <li>Manage and screen the content and photos, to the satisfaction of our Seller</li>
                        </ul>
                    </div>
                    <div class="column">
                        <img alt="House for sale" src="../assets/images/for_agents/what_we_do.svg">
                    </div>
                </div>
            </div>
        </section>

        <section class="section has-background-light-blue">
            <div class="container">
                <br>
                <div class="columns is-vcentered reversible">
                    <div class="column">
                        <img alt="House for sale with esate agents" src="../assets/images/for_agents/what_you_do.svg">
                    </div>
                    <div class="column">
                        <h3 class="title">What you do as the Buyers' Agent</h3>
                        <ul class="ul-bullets">
                            <li>List the property on listing sites</li>
                            <li>Schedule viewings with your buyers</li>
                            <li>Facilitate viewings</li>
                            <li>Secure buyer offers</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <br>
                <div class="columns is-vcentered">
                    <div class="column">
                        <h3 class="title">Together we</h3>
                        <ul class="ul-bullets">
                            <li>Negotiate offers</li>
                            <li>Represent our respective customers</li>
                            <li>Finalise the SALE</li>
                        </ul>
                    </div>
                    <div class="column">
                        <img alt="Sold House" src="../assets/images/for_agents/together_we.svg">
                    </div>
                </div>
            </div>
        </section>

        <section class="section has-background-light-blue has-text-centered">
            <div class="container">
                <br>
                <h3 class="title">Sharing agents commission</h3>
                <p>NestEgg does not charge the customer - our Sellers Agent and Listing Fee is simply 40% of our Partner Agent's commission on sale of the property.</p>
                <br>
                <p><strong>For example: R2 000 000</strong></p>
                <br>
                <table class="table">
                    <tr>
                        <td>Property Sale Value</td>
                        <td>R2 000 000</td>
                    </tr>
                    <tr>
                        <td>Total negotiated Commission - 5%*</td>
                        <td>R100 000</td>
                    </tr>
                    <tr>
                        <td>What you get - 60%*</td>
                        <td>R60 000</td>
                    </tr>
                    <tr>
                        <td>NestEgg gets - 40%*</td>
                        <td>R40 000</td>
                    </tr>
                </table>
                <p><strong>* All figures above exclude VAT</strong></p>
            </div>
        </section>

        <section class="section has-text-centered">
            <div class="container">
                <br>
                <div class="columns">
                    <div class="column">
                        <img alt="Traditional Agent Sharing Model" class="model-graph" src="../assets/images/for_agents/traditional_agent_graph.svg">
                    </div>
                    <div class="column">
                        <img alt="NestEgg Partner Model" class="model-graph" src="../assets/images/for_agents/nestegg_partner_graph.svg">
                    </div>
                </div>
            </div>
        </section>

        <section class="section has-background-light-blue has-text-centered">
            <div class="container">
                <br>
                <h3 class="title">What we look for in agents</h3>
                <br>
                <div class="columns is-vcentered has-text-left">
                    <div class="column agents-column">
                        <img alt="Blue Tick" src="../assets/images/for_agents/tick_blue.svg">
                        <span>Proven area sales record</span>
                    </div>
                    <div class="column agents-column">
                        <img alt="Purple Tick" src="../assets/images/for_agents/tick_purple.svg">
                        <span>Great reviews from Clients</span>
                    </div>
                    <div class="column agents-column">
                        <img alt="Green Tick" src="../assets/images/for_agents/tick_green.svg">
                        <span>Excellent local market knowledge</span>
                    </div>
                    <div class="column agents-column">
                        <img alt="Red Tick" src="../assets/images/for_agents/tick_red.svg">
                        <span>Full Time Professional Agents with a valid FFC</span>
                    </div>
                </div>
                <br>
                <router-link class="button is-primary" to="/contact-us">Contact us now to find out more</router-link>
            </div>
        </section>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';

    .table {
        margin-left: auto;
        margin-right: auto;

        border-collapse: separate;
        border-spacing: 5px 7px;
        background: none !important;

        tr {
            color: $primary;
        }

        td {
            border: 1px solid $primary !important;
            border-radius: 3px;
            background-color: white;
        }

        tr:nth-child(-n + 2) td {
            background-color: $primary;
            color: white;
            font-weight: 700;
        }

        td:nth-child(2) {
            text-align: right !important;
        }
    }

    .model-graph {
        height: 65vh;
    }

    .agents-column {
        display: flex;
        align-items: center;

        img {
            max-width: 120px;
        }
    }
</style>